<template>
  <span>
    <div class="preview-content">
      <!-- プレゼンシート -->
      <div class="presentation-sheet-preview">
        <div class="presentation-sheet-preview-block">
          <h3>プラン情報</h3>
          <table>
            <tr>
              <th>物件名</th>
              <td class='wide'>{{ presentationSheetModel.propertyName }}</td>
            </tr>
            <tr>
              <th>プラン製品品番</th>
              <td class='wide'>{{ presentationSheetModel.planUmCode }}</td>
            </tr>
            <tr>
              <th>プラン名</th>
              <td class='wide'>{{ presentationSheetModel.planName }}</td>
            </tr>
          </table>
        </div>
        <div class="presentation-sheet-preview-block">
          <h3>プレゼンシート出力内容</h3>
          <table>
            <tr>
              <th>UMコード</th>
              <th>文字列（短）1</th>
              <th>文字列（短）2</th>
              <th>文字列（短）3</th>
              <th>文字列（長）</th>
              <th>画像ファイル名1</th>
              <th>画像ファイル名2</th>
              <th>カテゴリー1</th>
              <th>カテゴリー2</th>
              <th>カテゴリー3</th>
              <th>優先度</th>
              <th>備考（出力対象外）</th>
            </tr>
            <tr v-for="(contentsModel, index) in this.presentationSheetModel.contentsModelList" v-bind:key="index">
              <td> {{ contentsModel.umCode }} </td>
              <td> {{ contentsModel.contentsTextShort1 }} </td>
              <td> {{ contentsModel.contentsTextShort2 }} </td>
              <td> {{ contentsModel.contentsTextShort3 }} </td>
              <td class='wide'> {{ contentsModel.contentsTextLong }} </td>
              <td> {{ contentsModel.contentsImageName1 }} </td>
              <td> {{ contentsModel.contentsImageName2 }} </td>
              <td class='narrow'> {{ contentsModel.contentsCategory1 }} </td>
              <td class='narrow'> {{ contentsModel.contentsCategory2 }} </td>
              <td class='narrow'> {{ contentsModel.contentsCategory3 }} </td>
              <td class='narrow'> {{ contentsModel.contentsPriority }} </td>
              <td class='wide'> {{ contentsModel.contentsRemark }} </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!-- ボタン -->
    <!-- <div class="button-area">
      <button type="button" class="main_btn" @click="$emit('outputPresentationSheet')">プレゼンシート送信</button>
      <span class="output-caution">※出力物はメールで送られます</span>
    </div> -->
  </span>
</template>
<script>

export default {
  name: 'PresentationSheetTab',
  props: {
    presentationSheetModel: Object
  }
}
</script>

<style lang="scss"  scoped>
.presentation-sheet-preview {
  height: 100%;
  width: 100%;
  overflow: scroll;
}
.presentation-sheet-preview-block {
  margin: 30px;
  table {
    width: auto;
    th {
      white-space: nowrap;
    }
    td {
      border: 1px solid #ddd;
      line-height: 20px;
      min-width: 150px;
      word-break: break-word;
      &.wide {
        min-width: 250px;
      }
      &.narrow {
        min-width: 0px;
        word-break: normal;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/sheet/PresentationSheetTab.vue